/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForAlertsGcp extends models.GovernanceConfigurationBaseForAlerts {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForAlertsGcp");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForAlertsGcp.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForAlertsGcp>): GovernanceConfigurationForAlertsGcp {
        let obj = Object.assign(new GovernanceConfigurationForAlertsGcp(), model);
        GovernanceConfigurationForAlertsGcp.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForAlertsGcp>): GovernanceConfigurationForAlertsGcp {
        if (!model) return null;
        return GovernanceConfigurationForAlertsGcp.newInstance(<GovernanceConfigurationForAlertsGcp> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForAlertsGcp) {
        if (!obj) return;

        models.GovernanceConfigurationForAlertsGcp.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForAlertsGcp): boolean {
        if (models.GovernanceConfigurationBaseForAlerts.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForAlertsGcp.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Notification Channel Name
     */
    notification_channel_name: string;

}
